module.exports = [
  '$resource',

  function OfferingResource(
    $resource,
  ) {
    return $resource('/api/v2/groups/:group_id/appointments/offerings',
      {},
      {
        query: {
          method: 'GET',
          isArray: true,
        },
      },
    );
  },
];



// WEBPACK FOOTER //
// ./main/factories/offering-resource.js